import Badge from "@mui/material/Badge";
import {colorize, customerInitials} from "../common/Utils";
import {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import Avatar from "@mui/material/Avatar";
import {Cake} from "@mui/icons-material";

export default function UserBadge(props) {

  const [context, setContext] = useContext(AppContext);
  const [user, setUser] = useState();
  const [admin, setAdmin] = useState(props.admin);
  const [birthday, setBirthday] = useState(false);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];
  const monthName = months[new Date().getMonth()];

  const birthdayMonth = (u) => {
    const monthName = months[new Date().getMonth()].toUpperCase();
    return u?.birthdayMonth === monthName;
  }

  useEffect(() => {
    if (!context?.sessionUser) {
      return;
    }
    let _user;
    if (admin) {
      _user = context.sessionUser?.adminUser || context.sessionUser;
      setUser(_user);
    } else {
      _user = context.sessionUser;
      setUser(_user);
    }
    if (birthdayMonth(_user)) {
      setBirthday(true);
    }

  }, [context?.sessionUser]);

  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    if (!birthday) {
      return;
    }
    const timer = setTimeout(() => {
      setAnimate(false);
    }, 8000);
    return () => clearTimeout(timer);
  }, [birthday]);

  const rainbowCircleStyle = {
    background: `
    radial-gradient(
      circle,
      #ff8800,
      #00ff66,
      #00ccff,
      #aa00ff
    )
  `,
    backgroundSize: "100% 100%",
    color: "white",
    animation: animate
      ? "rainbowPulse 4s linear infinite"
      : "none",
  };

  return (
    <Badge>
      {birthday && <Avatar title={"Happy Birthday!"} alt={user?.email} style={rainbowCircleStyle}>
        <Cake/>
      </Avatar>
      }
      {!birthday && <Avatar alt={user?.email} style={{
        backgroundColor: colorize(user?.email),
      }}>
        {customerInitials(user)}
      </Avatar>}
    </Badge>
  )
}